var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 106,
    viewBox: "0 0 59 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2805_1694)",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.061 37.52h.6c9.72 0 14.04 7.32 14.04 16.56V74.6c0 11.76-6.72 21-21 21h-2.88c-15.72 0-21.24-8.76-21.24-21V24.56c0-11.28 5.4-20.16 20.04-20.16h2.88c15.36 0 20.16 7.68 20.16 19.44v6.96h-15.84v-5.52c0-5.16-1.68-7.2-5.64-7.2-3.84 0-5.64 2.16-5.64 7.2v19.8c1.32-1.92 6.12-7.56 14.52-7.56zm-14.52 36.72c0 5.16 2.52 7.68 6.6 7.68 4.32 0 6.6-2.52 6.6-7.68v-15.6c0-5.4-2.28-7.92-6.6-7.92-4.08 0-6.6 2.52-6.6 7.68v15.84z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.061 37.52h.6c9.72 0 14.04 7.32 14.04 16.56V74.6c0 11.76-6.72 21-21 21h-2.88c-15.72 0-21.24-8.76-21.24-21V24.56c0-11.28 5.4-20.16 20.04-20.16h2.88c15.36 0 20.16 7.68 20.16 19.44v6.96h-15.84v-5.52c0-5.16-1.68-7.2-5.64-7.2-3.84 0-5.64 2.16-5.64 7.2v19.8c1.32-1.92 6.12-7.56 14.52-7.56zm-14.52 36.72c0 5.16 2.52 7.68 6.6 7.68 4.32 0 6.6-2.52 6.6-7.68v-15.6c0-5.4-2.28-7.92-6.6-7.92-4.08 0-6.6 2.52-6.6 7.68v15.84z",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2805_1694",
    x: -4.919,
    y: -4.1,
    width: 63.12,
    height: 109.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2805_1694"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_2805_1694",
    result: "effect2_dropShadow_2805_1694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2805_1694",
    result: "shape"
  })))));
}
Svg6.displayName = '6';
export default Svg6;